import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-activity",
  "use": "icon-activity-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-activity\"><path d=\"M1.1 10h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1H1.1C.492 12 0 11.552 0 11s.492-1 1.1-1zm0-7h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1H1.1C.492 5 0 4.552 0 4s.492-1 1.1-1zm0 14h19.8c.608 0 1.1.448 1.1 1s-.492 1-1.1 1H1.1C.492 19 0 18.552 0 18s.492-1 1.1-1z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol